<template>
<m-pageframe
    title="BigCommerce Connect Organization"
>
<v-container
    fluid
    style="padding-left: 25px; padding-right: 25px"
>

    <h1
        style="margin-bottom: 15px"
    >
        Connect BigCommerce to RedChirp
    </h1>

    <p>Select the organization that you would like to connect this BigCommerce store to</p>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        v-on:click:row="onClickOrganization"
    >
        <!--
        <template v-slot:item.some_field="{ item }">
            {{item.some_field}}
        </template>-->
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    
    data() {
        return {
            results: [],
            full_text: null,
            headers: [
                { text: 'Organization', value: 'label'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/organization/list-organizations-actor-can-access',
            
                'params' : {
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list organizations',
            });
        },

        onClickOrganization(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/integrations/big-commerce/pair',
            
                'params' : {
                        'organization_id': item.organization_id,
                        'store_hash': this.$route.params.store_hash,
                    },
            
                'on_success': (data) => {
                        this.$router.push({
                            'name': 'big-commerce-pair-organization-complete',
                            'params' : {
                            }
                        });
                    },
            
                'on_error': 'Unable to pair organization with BigCommerce',
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>